const isContactLensesSubscriptionLineItem = (lineItem)=>lineItem.type === 'contact-lenses-subscription'
;

export { isContactLensesSubscriptionLineItem };
//# sourceMappingURL=is-contact-lenses-subscription-line-item.js.map
